import { createElementBlock as t, openBlock as o, createElementVNode as r } from "vue";
import n from "./index289.js";
const c = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function a(m, e, l, p, i, f) {
  return o(), t("svg", s, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      d: "M12 2.25a5.753 5.753 0 0 1 5.541 4.21 5.752 5.752 0 0 1 0 11.081 5.752 5.752 0 0 1-11.082 0 5.752 5.752 0 0 1 0-11.082A5.752 5.752 0 0 1 12 2.25Zm3.874 15.5H8.126a4.25 4.25 0 0 0 7.748 0Zm.126-10H8c-.082 0-.163.002-.243.007-.005.08-.007.161-.007.243v8c0 .082.002.163.007.243.08.005.161.007.243.007h8c.082 0 .163-.002.243-.007.005-.08.007-.161.007-.243V8c0-.082-.002-.163-.007-.243A4.172 4.172 0 0 0 16 7.75Zm-9.75.376a4.25 4.25 0 0 0 0 7.748Zm11.5 0v7.748a4.25 4.25 0 0 0 0-7.748ZM12 3.75a4.25 4.25 0 0 0-3.874 2.5h7.748A4.25 4.25 0 0 0 12 3.75Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ n(c, [["render", a]]);
export {
  u as default
};
